<template>
    <footer class="footer">
        <div class="container">
            <div class="row align-items-center justify-content-md-between">
                <div class="col-md-6">
                    <div class="copyright">
                        &copy; {{year}}
                        AUGE SD
                    </div>
                </div>
                <div class="col-md-6">
                    <ul class="nav nav-footer justify-content-end">
                        <li class="nav-item">
                            <router-link to="/tos" class="nav-link">Terms</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="/privacy" class="nav-link">Privacy</router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
export default {
    name: "small-footer",
    data() {
        return {
            year: new Date().getFullYear()
        };
    }
};
</script>
<style>
</style>
